.ExpandableArrow {
  --ExpandableArrow-duration: 200ms;
  --ExpandableArrow-easing: ease;

  transition: transform var(--ExpandableArrow-duration) var(--ExpandableArrow-easing);
  transform: translateX(0);
}

.ExpandableArrow--expanded {
  transform: translateX(4px);
}

.ExpandableArrow-stem {
  stroke-dasharray: 10;
  stroke-dashoffset: 10;
  transition: stroke-dashoffset var(--ExpandableArrow-duration) var(--ExpandableArrow-easing);
}

.ExpandableArrow-stem--expanded {
  stroke-dashoffset: 20;
}

.ExpandableArrow--reversed {
  transform: rotate(180deg);
}

.ExpandableArrow--reversed.ExpandableArrow--expanded {
  transform: rotate(180deg) translateX(4px);
}
